import React, { useState } from 'react';
import { Form, Image } from 'react-bootstrap';
import '../../../Assets/css/myaccount.css'
import { Breadcrumbs, Link, Typography } from '@material-ui/core';
import TextField from '@mui/material/TextField';
import { Col, Container, Row } from 'react-bootstrap';
import Button from '@mui/material/Button';
import ReCAPTCHA from "react-google-recaptcha";
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import Social1 from '../../../Assets/images/static/Social/1.png';
import Social2 from '../../../Assets/images/static/Social/2.png';
import Social3 from '../../../Assets/images/static/Social/3.png';
import Social4 from '../../../Assets/images/static/Social/4.png';
import Social5 from '../../../Assets/images/static/Social/5.png';
import Social6 from '../../../Assets/images/static/Social/6.png';
import Social7 from '../../../Assets/images/static/Social/7.png';
import { NavLink } from 'react-router-dom';
import axios from 'axios';
import { base_url, postHeader } from '../../../Helpers/request';
import swal from 'sweetalert';
import { Helmet } from 'react-helmet';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';

const Contact = () => {
    const metaDetails = useSelector(state => state.persistedReducer.meta.meta)
    const [first_name, setFirst_name] = useState('');
    const [capchaloading , setCapchaLoading] = useState(true)
    const [last_name, setLast_name] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [comment, setComment] = useState('');

    useEffect(() => {
        window.scrollTo(0, 0);
    })
    
    const onChange = (value) => {
     if(value){
        setCapchaLoading(false)
     }
    }
  
    const onExpire = () => {
        setCapchaLoading(true)
    }

    const formsubmit = (e) => {
        e.preventDefault();
        var data = {
            first_name,
            last_name,
            email,
            phone,
            comment
        }
        axios.post(base_url + '/user/contact', data, {
            headers: postHeader
        })
            .then(response => {
                if (response.data.status == 1) {
                    setFirst_name("");
                    setLast_name("");
                    setEmail("");
                    setComment("");
                    setPhone("");
                    return swal(response.data.message, "", "success");
                } else {
                    return swal(response.data.message, "", "error");
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }
    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>{metaDetails?.title}</title>
                <meta name="description" content={metaDetails?.description}></meta>
                <meta name="keywords" content={metaDetails?.keywords}></meta>
            </Helmet>
            <div className="rcs_myaccount_section">
                <Container>
                    <Row>
                        <Col className="rcs_breadcrumb mb-2">
                            <Breadcrumbs aria-label="breadcrumb">
                                <NavLink underline="hover" color="inherit" to="/">
                                    Home
                                </NavLink>
                                <Typography color="text.primary">Contact Us</Typography>
                            </Breadcrumbs>
                        </Col>
                    </Row>
                </Container>
                <div className="rcs_appointment mt-5">
                    <Container>
                        <Row className="w-100 m-auto">
                            <Col className="p-md-0 mb-5">
                                <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d92374.9487127337!2d-79.4494563!3d43.6540529!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89d4cb34a5006187%3A0x7d775a6a5641f2d!2sDiamonds%20For%20Less!5e0!3m2!1sen!2sin!4v1669802682368!5m2!1sen!2sin" width="100%" height="450" style={{ border: "0" }} allowfullscreen="" loading="lazy"></iframe>
                            </Col>
                        </Row>
                        <Row className="w-100 m-auto">
                            <Col sm={12} md={6} className="p-md-0">
                                <Form onSubmit={formsubmit}>
                                    <Row>
                                        <Col xs={12} sm={6}>
                                            <TextField
                                                id="outlined-basic"
                                                label="First Name"
                                                type="text"
                                                variant="outlined"
                                                value={first_name}
                                                onChange={(e) => setFirst_name(e.target.value)}
                                                required
                                            />
                                        </Col>
                                        <Col xs={12} sm={6}>
                                            <TextField
                                                id="outlined-basic"
                                                label="Last Name"
                                                type="text"
                                                variant="outlined"
                                                value={last_name}
                                                onChange={(e) => setLast_name(e.target.value)}
                                                required
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={12} sm={6}>
                                            <TextField
                                                id="outlined-basic"
                                                label="Email Address"
                                                type="Email"
                                                variant="outlined"
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                                required
                                            />
                                        </Col>
                                        <Col xs={12} sm={6}>
                                            <TextField
                                                id="outlined-basic"
                                                label="Phone"
                                                type="number"
                                                variant="outlined"
                                                InputProps={{ inputProps: { min: 0 } }}
                                                value={phone}
                                                onChange={(e) => setPhone(e.target.value)}
                                                required
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={12}>
                                            <TextField
                                                id="filled-multiline-static"
                                                label="Your Message"
                                                multiline
                                                rows={4}
                                                variant="outlined"
                                                value={comment}
                                                onChange={(e) => setComment(e.target.value)}
                                            />
                                        </Col>
                                        <Col xs={12} >
                                        <ReCAPTCHA
                                        sitekey="6Lc6LUscAAAAAKO2DYPGrIPSnwx3fzROCxJzNWQ0"
                                        onChange={onChange}
                                        onExpired = {onExpire}
                                        />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col className="mt-3" >
                                            <Button disabled = {capchaloading ? true : false}  variant="contained" type="submit" className="rcs_acc_button"> <MailOutlineIcon className="mr-2" /> Send Message </Button>
                                        </Col>
                                    </Row>
                                </Form>
                            </Col>
                            <Col sm={12} md={6}>
                                <div className="rcs_contact_content">
                                    <h1>Contact Us</h1>
                                    <p>Please send us a message, and our staff will be happy to help you with any questions you have.</p>
                                    <ul className="rcs_content_address">
                                        <li>
                                            <h5>STORE ADDRESS</h5>
                                            <address className="mb-0">
                                                <a target="_blank " href="https://www.google.com/maps/dir/5+Shuter+St,+Toronto,+ON+M5B+2H8,+Canada/@43.6540529,-79.4494563,12z/data=!4m8!4m7!1m0!1m5!1m1!1s0x89d4cb34a5006187:0x7d775a6a5641f2d!2m2!1d-79.3794165!2d43.6540743">5 Shuter St, Toronto,<br />ON M5B 2H8, Canada</a>
                                            </address>
                                        </li>
                                        <li>
                                            <h5>STORE HOURS</h5>
                                            <strong>Mon - Fri:</strong> 10:00 am - 6:00 pm<br />
                                            <strong>Sat:</strong> 10:00 am - 4:00 pm<br />
                                            <strong>Sun:</strong> Closed<br />
                                        </li>
                                    </ul>
                                    <h4 className='pb-0'>Contact US:</h4>
                                    <ul>
                                        <li className='dfl_contact_numberrr'><a href='tel:+1 416 362 9944'><strong>+1 416 362 9944</strong></a></li>
                                    </ul>
                                    <h4>FOLLOW US</h4>
                                    <ul className="rcs_content_social">
                                        <li><a href="https://www.facebook.com/pg/DiamondsForLess/reviews/" target="_blank"><Image src={Social1} alt="Facebook"></Image></a></li>
                                        <li><a href='https://twitter.com/diamondsforless' target="_blank"><Image src={Social7} alt="twitter"></Image></a></li>
                                        <li><a href='https://www.instagram.com/dfltoronto/?igshid=YmMyMTA2M2Y%3D' target="_blank"><Image src={Social2} alt="Instagram"></Image></a></li>
                                        <li><a href='https://www.yelp.ca/biz/diamonds-for-less-toronto' target="_blank"><Image src={Social5} alt="Instagram"></Image></a></li>
                                        {/* <li><NavLink className="disabled-link" to="#"><Image src={Social4} alt="Instagram"></Image></NavLink></li>
                                        <li><NavLink className="disabled-link" to="#"><Image src={Social3} alt="Linkdin"></Image></NavLink></li>              */}

                                        {/* <li><NavLink onClick={() => window.open("", "_blank")} to="#"><Image src={Social3} alt="Linkdin"></Image></NavLink></li>                                 */}
                                    </ul>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </div>
        </>
    )
}

export default Contact;